/*
 * <vt-quick-sizes>: the size panel on a product card's photo (quick add "Sizes on hover").
 *
 * Markup contract (see snippets/vitto-quick-sizes.liquid):
 *   <vt-quick-sizes>
 *     <div role="group"> <button data-variant-id="…">S</button> … <p class="vt-quick-sizes__error" role="alert" hidden></p> </div>
 *   </vt-quick-sizes>
 *
 * Clicking a size adds one of that variant to the cart, the way Dawn's product form does: the cart drawer (or Dawn's
 * cart popup) re-renders from the same response and opens. A refused add shows the shop's message in the panel.
 */
if (typeof customElements !== 'undefined' && !customElements.get('vt-quick-sizes')) {
  customElements.define(
    'vt-quick-sizes',
    class QuickSizes extends HTMLElement {
      constructor() {
        super();
        // Delegated and bound once: "Load more" moves cards between documents, which reconnects them.
        this.addEventListener('click', this.onClick.bind(this));
      }

      async onClick(event) {
        const button = event.target.closest('[data-variant-id]');
        if (!button || button.disabled || this.getAttribute('aria-busy') === 'true') return;
        event.preventDefault();

        const variantId = button.dataset.variantId;
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = new FormData();
        body.append('id', variantId);
        body.append('quantity', '1');
        if (cart) {
          body.append('sections', cart.getSectionsToRender().map((section) => section.id));
          body.append('sections_url', window.location.pathname);
          cart.setActiveElement(button);
        }

        this.showError('');
        this.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body,
          });
          const state = await response.json();
          if (state.status) {
            this.showError(state.description || state.message || window.cartStrings.error);
            return;
          }
          if (!cart) {
            this.navigate(window.routes.cart_url);
            return;
          }
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-sizes', productVariantId: variantId, cartData: state });
          cart.classList.remove('is-empty');
          cart.renderContents(state);
        } catch (error) {
          console.error(error);
          this.showError(window.cartStrings.error);
        } finally {
          this.removeAttribute('aria-busy');
          button.removeAttribute('aria-busy');
        }
      }

      showError(message) {
        const error = this.querySelector('.vt-quick-sizes__error');
        error.textContent = message;
        error.hidden = !message;
      }

      navigate(href) {
        window.location.href = href;
      }
    },
  );
}
